<template>
  <div style="height: 1000px">
    <!-- <el-row style="text-align: left">
      <el-button type="text" icon="el-icon-arrow-left" @click="back">返回登录页面</el-button>
    </el-row> -->
    <el-row style="margin-top: 20px">
      <el-collapse v-model="activeNames" style="text-align: left;">
        <el-collapse-item name="1">
          <template slot="title">
            <div style="font-size: 20px;font-weight: bold;background-color:#eee;width: 100% ;padding-left: 5px"> 基本信息
            </div>
          </template>
          <div style="font-size: 15px;padding-left:10px">
            <el-row :span="24">
              <el-col :span="12">
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">项目名称：</el-col>
                  <el-col :span="10">{{data.displayProjectName}}</el-col>
                </el-row>
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">报审编号：</el-col>
                  <el-col :span="10">{{data.id}}</el-col>
                </el-row>
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">联系人：</el-col>
                  <el-col :span="10">{{data.contactPerson}}</el-col>
                </el-row>
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">勘察单位：</el-col>
                  <el-col :span="10">{{data.surveyCorp}}</el-col>
                </el-row>
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">设计单位：</el-col>
                  <el-col :span="10">{{data.designCorp}}</el-col>
                </el-row>
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">联系人：</el-col>
                  <el-col :span="10">{{data.surveryProjecter}}</el-col>
                </el-row>
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">项目地址：</el-col>
                  <el-col :span="10">{{data.projectAddress}}</el-col>
                </el-row>
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">接审状态：</el-col>
                  <el-col :span="10">{{data.unionVerifyName}}</el-col>
                </el-row>
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">报审说明：</el-col>
                  <el-col :span="10">{{data.applyExplain}}</el-col>
                </el-row>
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">审查部门：</el-col>
                  <el-col :span="10">{{data.customerName}}</el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">勘前编号：</el-col>
                  <el-col :span="10">{{data.yTTaskID}}</el-col>
                </el-row>
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">建设单位：</el-col>
                  <el-col :span="10">{{data.constructCorp}}</el-col>
                </el-row>
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">联系电话：</el-col>
                  <el-col :span="10">{{data.contactPersonTel}}</el-col>
                </el-row>
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">资质等级：</el-col>
                  <el-col :span="10">{{data.surveyCorpGrade}}</el-col>
                </el-row>
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">资质等级：</el-col>
                  <el-col :span="10">{{data.designCorpGrade}}</el-col>
                </el-row>
                 <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">联系电话：</el-col>
                  <el-col :span="10">{{data.surveryTel}}</el-col>
                </el-row>
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">送审日期：</el-col>
                  <el-col :span="10">{{data.deliverDate}}</el-col>
                </el-row>
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">接审人：</el-col>
                  <el-col :span="10">{{data.taskApproverName}}</el-col>
                </el-row>
                 <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">报审状态：</el-col>
                  <el-col :span="10">{{data.applyState == 0?"提前受理":(data.applyState == 1?"材料齐全":"无")}}</el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <div style="font-size: 20px;font-weight: bold;background-color:#eee;width: 100%  ;padding-left: 5px">
              收费、颁证、变更、接审时间、接审状态、图纸接收退回原因
            </div>
          </template>
          <div style="font-size: 15px;padding-left:10px">
            <el-row :span="20">
              <el-col :span="10">
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="5">收费情况：</el-col>
                  <el-col :span="19">
                    <el-col :span="3">{{data.chargeStateName}}</el-col>
                    <el-col :span="6">
                       <el-button style="margin-bottom: 10px" @click="getCharge()" type="primary"
                               size="small">下载收费单
                      </el-button>
                       <!-- <el-button style="margin-bottom: 10px" @click="mm()" type="primary"
                               size="small">下载收费单
                      </el-button> -->
                    </el-col>
                  </el-col>
                </el-row>
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="5">接审时间：</el-col>
                  <el-col :span="10">{{data.acceptDate}}</el-col>
                </el-row>
                <el-row :span="8" style="text-align: left;margin-top: 10px">
                  <el-col :span="5">任务负责人：</el-col>
                  <el-col :span="10">{{data.taskResponsibleManName}}</el-col>
                </el-row>
                <el-row :span="8" style="text-align: left;margin-top: 10px">
                  <el-col :span="5">退回原因：</el-col>
                  <el-col :span="10">{{data.censorOpinion1}}</el-col>
                </el-row>
              </el-col>
              <el-col :span="10">
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">颁证情况：</el-col>
                  <el-col :span="10" v-if="data.censorCircs >= 8">已颁证
                    <el-button style="margin-left: 50px;margin-bottom: 10px"
                               @click="gethegeshu(url.generate_report_common+$route.query.id+'?type=censorType&param=_gz&status=view')"
                               type="primary" size="small">下载审查意见书
                    </el-button>
                  </el-col>
                  <el-col :span="10" v-else>未颁证</el-col>
                </el-row>
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">接审状态：</el-col>
                  <el-col :span="10" v-if="data.unionVerify == 1">已接审
                    <el-button style="margin-left: 50px;margin-bottom: 10px"
                        @click="getshoulishu"
                        type="primary" size="small">下载受理通知书
                    </el-button>
                  </el-col>
                  <el-col :span="10" v-else>未接审</el-col>
                </el-row>
                <el-row :span="10" style="text-align: left;margin-top: 10px">
                  <el-col :span="4">技术负责人：</el-col>
                  <el-col :span="10">{{data.techResponsibleManName}}</el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">
            <div style="font-size: 20px;font-weight: bold;background-color:#eee;width: 100%  ;padding-left: 5px">项目信息
            </div>
          </template>
          <el-row style="margin-top: 20px;padding-left:10px">
            <el-table
              :data="projectsTable.data"
              stripe
              style="width: 100%;text-align: left">
              <el-table-column
                type="index"
                width="50"
              >
              </el-table-column>
              <el-table-column
                prop="projectSubType"
                label="工程类型"
                width="160px">
              </el-table-column>
              <el-table-column
                prop="projectName"
                label="单体名称">
              </el-table-column>
              <el-table-column
                prop="agroundFloors"
                label="地上层数">
              </el-table-column>
              <el-table-column
                prop="undergroundFloors"
                label="地下层数">
              </el-table-column>
              <el-table-column
                prop="high"
                label="建筑高度">
              </el-table-column>
              <el-table-column
                prop="foundation"
                label="基础形式">
              </el-table-column>
              <el-table-column
                prop="structure"
                label="结构形式">
              </el-table-column>
              <el-table-column
                prop="function"
                label="使用功能">
              </el-table-column>
              <el-table-column
                prop="areas"
                label="总建筑面积">
              </el-table-column>
              <el-table-column
                prop="investment"
                label="投资额（万元）">
              </el-table-column>
              <el-table-column
                prop="manage"
                label="管理">
                <template slot-scope="scope">
                  <el-button type="text" @click="showDrawing(scope.row)">图纸信息</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="4">
          <template slot="title">
            <div style="font-size: 20px;font-weight: bold;background-color:#eee;width: 100%  ;padding-left: 5px">
              政策性审查材料
            </div>
          </template>
          <el-row style="padding-left:10px">
            <el-table
              :data="taskarchivesTable.data"
              stripe
              v-loading="taskarchivesTable.loading"
              style="width: 100%;text-align: left">
              <el-table-column
                type="index"
                width="50">
              </el-table-column>
              <el-table-column
                prop="archiveName"
                label="材料名"
              >
              </el-table-column>
              <el-table-column
                prop="archiveStatusText"
                label="材料状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.archiveStatusText === null">
                    缺
                  </div>
                  <div v-else>
                    {{scope.row.archiveStatusText}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="download"
                label="材料">
                <template slot-scope="scope">
                  <el-button type="text" @click="preview_pdf(scope.row.attachmentPath,scope.row.attachmentName)"
                             v-show="scope.row.archiveStatusText === '有'">预览
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column
                prop="manage"
                label="管理">
                <template slot-scope="scope">
                  <el-button type="text" @click="materials_show(scope.row.id)">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-dialog
            :title="materialsData.title"
            style="width: 100%;height: 100%"
            :visible.sync="materialsData.visible">
            <el-table :data="materialsData.data"
                      stripe
                      v-loading="materialsData.loading"
                      style="width: 100%;text-align: left">
              <el-table-column property="archiveName" label="材料名称"></el-table-column>
              <el-table-column property="attachmentName" label="附件名"></el-table-column>
              <el-table-column property="attachmentPath" label="操作">
                <template slot-scope="scope">
                  <el-button @click="download_template(scope.row.attachmentPath,scope.row.attachmentName)" type="text">
                    下载
                  </el-button>
                  <el-button @click="preview_pdf(scope.row.attachmentPath,scope.row.attachmentName)" type="text">预览
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-dialog>
        </el-collapse-item>
        <el-collapse-item name="5">
          <template slot="title">
            <div style="font-size: 20px;font-weight: bold;background-color:#eee;width: 100%  ;padding-left: 5px">审查信息
            </div>
          </template>
          <el-row style="margin-top: 20px;padding-left:10px">
            <el-table
              :data="opinionTable.data"
              v-loading="opinionTable.loading"
              stripe
              style="width: 100%;text-align: left">
              <el-table-column
                type="index"
                width="50">
              </el-table-column>
              <el-table-column
                prop="profession"
                label="专业"
              >
              </el-table-column>
               <el-table-column
                prop="projectName"
                label="子项名称"
              >
              </el-table-column>
               <el-table-column
                prop="projectSubType"
                label="子项工程类别"
              >
              </el-table-column>
              <el-table-column
                prop="masterCensorName"
                label="审查人">
              </el-table-column>
              <el-table-column
                prop="secondCensorName"
                label="复核人">
              </el-table-column>
              <el-table-column
                prop="assignTime"
                label="分配日期"
              >
              </el-table-column>
              <el-table-column
                prop="censorDate"
                label="审查日期"
              >
              </el-table-column>
              <el-table-column
                prop="test"
                label="审查意见"
              >
                <template slot-scope="scope">
                  <el-button type="text" @click="view_info(scope.row)" v-if="scope.row.checkOn >=4 && scope.row.checkOn <=8">查看</el-button>
                </template>
              </el-table-column>
              <el-table-column
                prop="test"
                label="回复意见"
              >
                <template slot-scope="scope">
                  <el-button type="text" @click="replay_info(scope.row)" v-if="scope.row.checkOn >=4 && scope.row.checkOn <=8">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
           <el-row style="margin-top:20px;text-align: right;">
            <el-pagination @size-change="pageSizeChange" @current-change="pageChange" :current-page="table.pagination.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="table.pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="table.pagination.total">
            </el-pagination>
          </el-row>
        </el-collapse-item>
         <el-collapse-item name="6">
          <template slot="title">
            <div style="font-size: 20px;font-weight: bold;background-color:#eee;width: 100%  ;padding-left: 5px">流程追踪
            </div>
          </template>
           <el-row style="margin-top: 50px">
              <el-table
                v-loading="tasklogTable.loading"
                :data="tasklogTable.data"
                stripe
                style="width: 100%;text-align: left">
                <el-table-column
                  type="index"
                  label="序号"
                  width="70">
                </el-table-column>
                <el-table-column
                  prop="stage"
                  label="阶段" >
                </el-table-column>
                <el-table-column
                  prop="operater"
                  label="操作者" >
                  <template slot-scope="scope">
                    <template v-if="scope.row.userName">
                      {{scope.row.userName}}
                    </template>
                    <template v-else>
                      {{scope.row.operater}}
                    </template>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="time"
                  label="日期" >
                </el-table-column>
                <el-table-column
                  prop="content"
                  label="内容" >
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="200">
                </el-table-column>
              </el-table>
            </el-row>
        </el-collapse-item> 
      </el-collapse>
    </el-row>
  </div>
</template>
<script>
  export default {
    data() {
      return {
         table: {
            pagination: {
            currentPage: 1,
            pageSize: 10,
            total: 0
          },
          data: [],
        },
        sessionID: '',
        tasklogTable:{
          data:[],
          loading:true,
        },
        checkof: {
          data: [],
          show: false,
          loading: true
        },
        project_show_detail:false,
        taskID: '',
        projectID: '',
        dialog: {
          title: '查看施工图文件',
          visible: false,
          data: [],
          pagination: {
            currentPage: 1,
            pageSize: 10,
            total: 0
          },
          loading: true,
          filterForm: {
            data: {
              project: ''
            }
          },
        },
        projectsTable: {
          data: [],
          pagination: {
            currentPage: 1,
            pageSize: 10,
            total: 0
          },
          loading: true,
        },
        taskarchivesTable: {
          data: [],
          pagination: {
            currentPage: 1,
            pageSize: 10,
            total: 0
          },
          loading: true,
        },
        data: {},
        activeNames: ['1', '2', '3', '4', '5', '6', '7', '8'],
        url: {
            task: '/draw/open',
            taskarchivesattachment: '/draw/taskarchivesattachment', //查看政策性材料
            mackcommon: '/draw/tasks/common_return_pdfUrl/',//查看意见,下载收费单
            reply: '/draw/opinions/reply-list',  //查看回复单
            acceptance: '/draw/tasks/pdf_notice_of_acceptance_xz/',//通知书
            session: '/draw/userinfo/session',
        },
        opinionTable: {
          data: [],
          pagination: {
            currentPage: 1,
            pageSize: 10,
            total: 0
          },
          loading: true,
        },
        materialsData: {
          title: '查看材料',
          visible: false,
          data: [],
          loading: false
        },
        number: ''
      }
    },
    created(){
        this.taskID = this.$route.query.id;
    },
    mounted() {
        this.queryCensorTask(this.taskID)
        this.queryProjects();
        this.queryTaskarchives();
        this.queryByCpId();
        this.queryOpinions();
    },
    methods: {
      project_show_details(row){
        const customerID = parseInt(this.data.customerID);
        let opinion = "opinion";
        switch (customerID) {
          case 255:
            opinion ="opinion";
            break;
          case 256:
            opinion ="opinion";
            break;
          case 257:
            opinion ="planningReview";
            break;
          case 258:
            opinion ="civilDefense";
            break;
          case 259:
            opinion ="evaluationOpinion";
            break;
          default:
            opinion ="opinion";
        }
        this.$http.get(
          this.url.mackcommon + this.taskID + "?type="+opinion+ "&profession=" + row.profession + "&status=view&number=" + row.number + "&projectId=" + row.id
        ).then((res) => {
          window.open(res.bodyText, "_blank")
        })
      },
      replay_info(row) {
         this.checkof.show = true
        this.checkof.loading = true;
        this.$http.get(this.url.reply,
          {params: {projectId: row.projectID, profession: row.profession}})
          .then(res => {
            this.checkof.data = res.body.result;
            this.checkof.loading = false;
          })
      },
      view_info(row){
        const customerID = parseInt(this.data.customerID);
        let opinion = "opinion";
        switch (customerID) {
          case 255:
            opinion ="opinion";
            break;
          case 256:
            opinion ="opinion";
            break;
          case 257:
            opinion ="planningReview";
            break;
          case 258:
            opinion ="civilDefense";
            break;
          case 259:
            opinion ="evaluationOpinion";
            break;
          default:
            opinion ="opinion";
        }
         this.$http.get(
          this.url.mackcommon + this.taskID + "?type="+opinion+ "&profession=" + row.profession + "&status=view&number=1"+ "&projectId=" + row.projectID
        ).then((res) => {
          window.open(res.bodyText, "_blank")
        })
      },
      queryByCpId(id){
        this.tasklogTable.loading = true;
        this.$http.get(
          this.url.task+"/taskLog/"+this.taskID
        ).then((res) => {
          if(res.body.status === 200){
            this.tasklogTable.data = res.data.result;
            this.tasklogTable.loading = false;
          }
        })
      },
      getCharge() {
          this.$http.get(
            this.url.mackcommon + this.taskID + "?type=charge&status=view"
          ).then((res) => {
            window.open(res.bodyText, "_blank");
          })
        },
        getshoulishu(){
        this.$http.get(
          this.url.acceptance + this.taskID+"?status=view"
        ).then((res) => {
          window.open(res.bodyText, "_blank");
        })
      },
      materials_show(id) {
        this.materialsData.loading = true;
        this.$http.get(
          this.url.task + "/taskarchivesattachment/" + this.taskID
          + "/" + id
          ,
        ).then((res) => {
          if (res.ok) {
            this.materialsData.data = res.data.result;
            this.materialsData.visible = true;
          } else {
            this.$message.error('查询失败，请联系管理员');
          }
          this.materialsData.loading = false;
        }, (error) => {
          this.materialsData.loading = false;
          this.$message.error('查询失败，请联系管理员');
        })
      },
      queryOpinions() {
        this.opinionTable.loading = true;
        this.$http.get(
          this.url.task + "/opinion/" + this.taskID+"?currentPage="+this.table.pagination.currentPage
          +"&pageSize="+this.table.pagination.pageSize
        ).then((res) => {
          if (res.body.status === 200) {
            this.opinionTable.data = res.data.result;
            this.opinionTable.loading = false;
          } else {
            this.opinionTable.loading = false;
          }
        })
      },
      queryProjects() {
        this.projectsTable.loading = true;
        this.$http.get(
          this.url.task + "/projects/" + this.taskID
        ).then((res) => {
          if (res.body.status === 200) {
            this.projectsTable.data = res.data.result;
            this.projectsTable.loading = false;
          } else {
            this.$message.error('查询失败，请联系管理员');
          }
        }, (error) => {
          this.$message.error('查询失败，请联系管理员');
        })
      },
      queryTaskarchives() {
        this.taskarchivesTable.loading = true;
        this.$http.get(
          this.url.task + "/archive/" + this.taskID
        ).then((res) => {
          if (res.body.status === 200) {
            this.taskarchivesTable.data = res.data.result;
            this.taskarchivesTable.loading = false;
          } else {
            this.$message.error('查询失败，请联系管理员');
          }
        }, (error) => {
          this.$message.error('查询失败，请联系管理员');
        })
      },
      queryCensorTask(id) {//查询task
        this.$http.get(
          this.url.task + "/detail?id=" + id,
        ).then((res) => {
          this.data = res.data.result;
        })
      },
      pageSizeChange(pageSize) { //每页数量改变
        this.table.pagination.pageSize = pageSize;
        this.queryOpinions();
      },
      pageChange(currentPage) { //翻页触发
        this.table.pagination.currentPage = currentPage;
        this.queryOpinions();
      },
      // back() {
      //   this.$router.go(-1)
      // },
      showDrawing(data) {
        let _this = this;
        let loading = this.$loading();

        function callBackBrowserURL(error, id) {
          if (error == 0) {  //调用成功
            //功能说明：监听AZTBrowser浏览器返回状态和数据
            //参数1：AZTBrowser浏览器的ID号
            //参数2：监听间隔时间，以秒位单位
            //参数3：回调函数
            AZTBrowser.waitStatus(id, "2", callBackWaitStatus);

          }else{
            //在这个地方判断
            loading.close();
            alert('请检查是否安装插件，如果没有安装，请至QQ服务群中下载最新"ESA电子签章客户端软件",安装即可')
		    }
        }
        //功能说明：监听AZTBrowser浏览器返回状态和数据
        //参数1：AZTBrowser浏览器的ID号，如果打开多个，此ID不同
        //参数2：状态值
        //参数3：AZTBrowser浏览器返回来的ID号
        //参数4：AZTBrowser浏览器返回来的内容
        function callBackWaitStatus(id, error, status, msg) {
           if(id === 'error'){
            alert('请检查是否安装插件，如果没有安装，请至QQ服务群中下载最新"ESA电子签章客户端软件",安装即可')
            }
          if (error == 0) {
            if (status == "0") {
              switch (msg) {
                case 'load':
                  loading.close();
                  break;
                case 'update':
                  _this.query();
                  break;
                  this.$message({type: "error", message: '错误:' + msg, showClose: true});
                  break;
              }
            } else {
              loading.close()
              this.$message({type: "error", message: '错误:' + msg, showClose: true});
            }
            //继续循环监听
            AZTBrowser.waitStatus(id, "2", callBackWaitStatus);
          }
        }

        //通过AZTBrowser来打开需要的地址


        //功能说明：创建AZTBrowser浏览器并打开URL地址
        //参数1：URL地址
        //参数2：是否置顶 1表示置顶，0表示不置顶
        //参数3：回调函数
        // if (this.sessionID) {
          // let gopdfurl = location.protocol + '//' + location.host + encodeURI(process.env.FATEPDFGBACK + data.taskID + '&session=' + this.sessionID)
          let gopdfurl = location.protocol + '//' + location.host + encodeURI(process.env.FATEPDFGBACK + data.taskID)
          console.log(gopdfurl)
          AZTBrowser.openBrowserURL(gopdfurl, "1", callBackBrowserURL);
        // } else {
        //   this.$message({type: 'error', message: '未知错误，请重新登录', showClose: true});
        // }
      },
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/login/skipDetails.vue